module.exports = __webpack_public_path__ + "static/media/jump.578439e6.fbx";